import CollectionItems from "%/dynamic-component-editor/standard-elements/CollectionItems.vue";
import CollectionItemsCommentsWidget from "%/dynamic-component-editor/standard-pages/collection-items-page/CollectionItemsCommentsWidget.vue";
import CollectionItemsTitle from "%/dynamic-component-editor/standard-pages/collection-items-page/CollectionItemsTitle.vue";
import CollectionItemsDescription from "%/dynamic-component-editor/standard-pages/collection-items-page/CollectionItemsDescription.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyCollectionItems extends LegacyEntity {
  get elements() {
    return {
      CollectionItems,
      CollectionItemsCommentsWidget,
      CollectionItemsTitle,
      CollectionItemsDescription,
    };
  }
}
